export enum ValueType{

    /**
     *å¼ç±»å
     */
    Value = 0,

    /**
     * è¡¨è¾¾å¼
     */
    Express = 1
}